import { useState } from 'react';
import { Link } from 'react-router-dom';
import ProductCard from '@/components/base/ProductCard';
import { products } from '@/mocks/products';

const tabs = [
  { key: 'hot', label: '热卖推荐' },
  { key: 'new', label: '新品上市' },
  { key: 'value', label: '超值优惠' },
];

const tabProducts: Record<string, string[]> = {
  hot: ['p1', 'p3', 'p5', 'p7'],
  new: ['p2', 'p4', 'p8', 'p11'],
  value: ['p6', 'p9', 'p12', 'p10'],
};

export default function FeaturedProducts() {
  const [activeTab, setActiveTab] = useState('hot');

  const currentProducts = (tabProducts[activeTab] || [])
    .map((id) => products.find((p) => p.id === id))
    .filter(Boolean);

  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-8">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-3">
            精选糖果推荐
          </h2>
          <p className="text-sm md:text-base text-foreground-500">
            严选品质，每一颗都让人回味无穷
          </p>
        </div>

        <div className="flex justify-center mb-8">
          <div className="inline-flex bg-background-100 rounded-full px-1 py-1">
            {tabs.map((tab) => (
              <button
                key={tab.key}
                onClick={() => setActiveTab(tab.key)}
                className={`px-5 py-2 rounded-full text-sm font-medium transition-all duration-200 whitespace-nowrap cursor-pointer ${
                  activeTab === tab.key
                    ? 'bg-primary-500 text-white'
                    : 'text-foreground-600 hover:text-foreground-800'
                }`}
              >
                {tab.label}
              </button>
            ))}
          </div>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {currentProducts.map((product) => (
            product && (
              <ProductCard
                key={product.id}
                id={product.id}
                name={product.name}
                price={product.price}
                originalPrice={product.originalPrice}
                image={product.image}
                badge={product.badge}
                category={product.category}
                rating={product.rating}
                reviews={product.reviews}
              />
            )
          ))}
        </div>

        <div className="text-center mt-8">
          <Link
            to="/category/fruit-candy"
            className="inline-flex items-center gap-2 px-6 py-2.5 rounded-full text-sm font-medium border border-primary-300 text-primary-600 hover:bg-primary-50 transition-colors whitespace-nowrap cursor-pointer"
          >
            查看更多糖果
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}